import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import commonFormMeta from '@Shared/components/form/commonFormMeta';
import { capitalize } from '@Shared/utils/helpers';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface IIndexFormMeta {
    identifier: FormInputMeta;
    bank: FormInputMeta;
    agency: FormInputMeta;
    parentGroup: FormInputMeta;
    category: FormInputMeta;
    promoter: FormInputMeta;
    requestDate: FormInputMeta;
    status: FormInputMeta;
    
    schema: any;
  }

const IndexFormMeta = {} as IIndexFormMeta;

IndexFormMeta.identifier = {
  name: 'identifier',
  type: 'text',
  label: 'ID',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
IndexFormMeta.bank = {
  name: 'bank',
  label: 'Banque',
  type: "select",
  options:  [
    {
      label: 'Banque A',
      value: 'a'
    },
    {
      label: 'Banque B',
      value: 'b',
    },
    {
      label: 'Banque C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};
IndexFormMeta.agency = {
  name: 'agency',
  label: 'Agence',
  type: "select",
  options:  [
    {
      label: 'Agence A',
      value: 'a'
    },
    {
      label: 'Agence B',
      value: 'b',
    },
    {
      label: 'Agence C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};
IndexFormMeta.parentGroup = {
  name: 'parentGroup',
  label: 'Groupe parent',
  type: "select",
  options:  [
    {
      label: 'Groupe parent A',
      value: 'a'
    },
    {
      label: 'Groupe parent B',
      value: 'b',
    },
    {
      label: 'Groupe parent C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};
IndexFormMeta.category = {
  name: 'category',
  label: 'Categorie',
  type: "select",
  options:  [
    {
      label: 'Categorie A',
      value: 'a'
    },
    {
      label: 'Categorie B',
      value: 'b',
    },
    {
      label: 'Categorie C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};
IndexFormMeta.promoter = {
  name: 'promoter',
  label: 'Promoteur',
  type: "select",
  options:  [
    {
      label: 'Promoteur A',
      value: 'a'
    },
    {
      label: 'Promoteur B',
      value: 'b',
    },
    {
      label: 'Promoteur C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};

IndexFormMeta.requestDate = {
  name: 'requestDate',
  type: 'date',
  label: 'Date demande',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
IndexFormMeta.status = {
  name: 'status',
  type: 'text',
  label: 'Statut',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

IndexFormMeta.schema = yup.object().shape(getValidationSchema(IndexFormMeta));

export default IndexFormMeta;